import { render, staticRenderFns } from "./PlanIcon.vue?vue&type=template&id=b2129bd0&scoped=true"
import script from "./PlanIcon.vue?vue&type=script&lang=js"
export * from "./PlanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2129bd0",
  null
  
)

export default component.exports